module.exports = __webpack_public_path__ + "static/img/fontawesome-webfont.912ec66d.svg";